import { withSection } from "./Section";
import MagazineTeaserComponent, {
  MagazineTeaserProps
} from "../magazin/MagazineTeaser";

const MagazineTeaserSection = withSection<MagazineTeaserProps>(
  MagazineTeaserComponent,
  null,
  p =>
    (!p.portraits && !p.news) || (p.portraits.total === 0 && p.news.total === 0)
);

export default MagazineTeaserSection;
